import { SwitchProps } from "@mcleod/components";
import { AbstractComponentDemoExamples } from "./AbstractComponentDemoExamples";

export class DemoSwitchExamples extends AbstractComponentDemoExamples {
    protected override registerExamples() {
        super.registerExamples();
        this.registerPropertyExamples("printable", {
            examples: [
                { value: true, description: "This example shows how a printable Switch is displayed." },
                { value: false, description: "This Switch is normal." }
            ]
        });
    }

    protected override get propsForAllExamples(): Partial<SwitchProps> {
        return {
            ...super.propsForAllExamples,
            caption: "Switch Demo"
        };
    }
}
